import type { ReactNode } from "react";
import { TabScreen, Tabs, TabsProvider } from "react-native-paper-tabs";
import { useAppTheme } from "../useAppTheme";

interface TabData {
	label: string;
	content: ReactNode;
	badge?: string | number | boolean;
	icon?: string;
}

interface Props {
	tabs: TabData[];
	mode?: "scrollable" | "fixed";
	onChangeIndex?: (index: number) => void;
	backgroundColor?: string;
}

const CustomTabs = ({
	tabs,
	mode = "fixed",
	onChangeIndex,
	backgroundColor,
}: Props) => {
	const theme = useAppTheme();

	return (
		<TabsProvider onChangeIndex={onChangeIndex}>
			<Tabs
				style={{
					backgroundColor: backgroundColor ?? theme.colors.elevation.level3,
				}}
				mode={mode}
				theme={{
					colors: {
						primary: theme.colors.primary,
					},
				}}
			>
				{tabs.map((item) => (
					<TabScreen
						badge={item.badge}
						key={item.label}
						label={item.label}
						icon={item.icon}
					>
						{item.content}
					</TabScreen>
				))}
			</Tabs>
		</TabsProvider>
	);
};

export default CustomTabs;
